import React from "react";

//Module Imports
import moneyFormat from "@/modules/moneyFormat";

import {
	replaceGameNameWithURL,
	getTranslatedGameName,
	showTypeResultHistory,
} from "@/modules/commonMobile";

import { isIPhone } from "@/modules/iOSDetection";
import { getBasePcode } from "@/modules/gamePcode";

import { Pagination } from "@/modules/commonPopupResultHistory";

import dateTimeFormat from "@/modules/dateTimeFormat";
import thousandsFormat from "@/modules/thousandsFormat";

//Type Imports
import {
	IGameObjectType,
	ILanguageType
} from "@/types/GlobalTypes";

import {
	ITransactionHistoryType,
	ITransactionType
} from "@/types/TransactionTypes";

import "../PopupResultHistory/index.scss";

interface IProps {
	games: IGameObjectType;
	langdata: ILanguageType;
	currency: string;

	desktop?: boolean;
	mobile?: boolean;

	transactionHistoryData: ITransactionHistoryType;

	transactionHistoryPage: number;
	changeTransactionPage: (e: any) => void;

	toggleTransactionDetail: (e: any) => void;
	fetchTransactionHistory: (e: any) => void;

	togglePopupTransactionHistory?: (e: any) => void; //for mobile
}

export default class PopupTransactionHistory extends React.Component<IProps> {
	get headerAry() {
		const { langdata } = this.props;

		return [
			langdata["txt_number_pagination"],
			langdata["txt_periode"],
			langdata["txt_date"],
			// langdata["txt_detail"],
			langdata["txt_status"],
			// langdata["txt_debit"],
			// langdata["txt_credit"],
			langdata["txt_amount"],
			langdata["txt_balance"]
		];
	}

	get headerDiv() {
		const {
			fetchTransactionHistory,
			togglePopupTransactionHistory
		} = this.props;

		return (
			<div key="PTH_header" className="popup-header">
				Transaction History
				<div className="refresh"
					{...{ page: 1 }}
					onClick={fetchTransactionHistory}>
					Refresh
				</div>
				<i className={"sl-ic-close close"}
					onClick={togglePopupTransactionHistory} />
			</div>
		);
	}

	get emptyTransactionHistoryTable() {
		const {
			desktop,
			langdata
		} = this.props;

		return (
			<>
				{/* //Empty transaction history entry */}
				{this.headerDiv}

				<table key="PTH_table"
					className={
						"transaction-history-table" +
						(desktop ? " desktop" : "") +
						(isIPhone() ? " iphone" : "")
					}>
					<thead>
						<tr className="row-header">
							{
								this.headerAry.map((item, idx) =>
									<th key={`TH_tht_th_${idx}`}>{item}</th>
								)
							}
						</tr>
					</thead>

					<tbody>
						<tr>
							<td colSpan={6} style={{ textAlign: "center" }}>
								<div>({langdata["txt_no_data_available"]})</div>
							</td>
						</tr>
					</tbody>
				</table>
			</>
		);
	}

	hasTypeColumn = (pcode: string) =>
		showTypeResultHistory.includes(getBasePcode(pcode));

	getDebitHeaders(pcode: string) {
		const { langdata } = this.props;

		const detailDebitHeaders = [
			langdata["txt_number_pagination"],
			langdata["txt_bet"],
			langdata["txt_amount"],
		];

		// for Toto Macau
		const detailDebitHeadersTM = [
			langdata["txt_number_pagination"],
			langdata["txt_bet"],
			langdata["txt_type"],
			langdata["txt_amount"],
		];

		return (
			this.hasTypeColumn(pcode)
				? detailDebitHeadersTM
				: detailDebitHeaders
		).map((_item, _idx) =>
			<th key={"TH_tHO_tD_th_" + _idx}>
				{_item}
			</th>
		);
	}

	getWinHeaders(pcode: string) {
		const { langdata } = this.props;

		//Detail Headers
		// (sub transaction row)
		const detailHeaders = [
			langdata["txt_number_pagination"],
			langdata["txt_bet"],
			langdata["txt_amount"],
			langdata["txt_prize"],
			langdata["txt_x_win"]
		];

		// Toto Macau
		const detailHeadersTM = [
			langdata["txt_number_pagination"],
			langdata["txt_bet"],
			langdata["txt_type"],
			langdata["txt_amount"],
			langdata["txt_prize"],
			langdata["txt_x_win"]
		];

		return (
			this.hasTypeColumn(pcode)
				? detailHeadersTM
				: detailHeaders
		).map((item, idx) =>
			<th key={"TH_tHO_tD_th_" + idx}>
				{item}
			</th>
		);
	}

	getTransactionDetailRows(transactionItem: ITransactionType) {
		const {
			langdata,
			currency
		} = this.props;

		const {
			transactionDetail,
			pasar,
			status
		} = transactionItem;

		const isWin = status === "Win";

		return !transactionDetail || transactionDetail.length === 0
			? (
				<tr>
					<td colSpan={this.getWinHeaders(pasar).length}>
						(No data)
					</td>
				</tr>
			) : (
				transactionDetail.map((detailRow, detailIdx) => {
					// Todo: refactor this

					return (
						<tr key={"TH_tHO_tD_tr" + detailIdx}>
							<td>
								{detailIdx + 1}
							</td>

							<td>
								{
									detailRow.convertedTebak
										? detailRow.convertedTebak
										: detailRow.tebak
								}
							</td>

							{
								this.hasTypeColumn(pasar)
									? <td>{detailRow.type}</td>
									: null
							}

							<td>
								{moneyFormat(detailRow.taruhan, langdata.language_code, currency)}
							</td>

							{
								isWin ? <>
									<td>
										{thousandsFormat(detailRow.prize, langdata.language_code)}
									</td>
									<td>
										{moneyFormat(detailRow.total, langdata.language_code, currency)}
									</td>
								</> : null
							}
						</tr>
					)
				})
			);
	}

	get splitTransactionTR() {
		const {
			transactionHistoryData,
			toggleTransactionDetail,

			games,
			langdata,
			currency,

			transactionHistoryPage
		} = this.props;

		const splitTransaction = transactionHistoryData.transaction.slice(
			(transactionHistoryPage - 1) * 15,
			(transactionHistoryPage) * 15
		);

		return (
			splitTransaction.map((item, idx) => {
				// pasar in this case is actually pcode
				const {
					debet,
					kredit,
					idbel,
					pasar,
					periode,
					status,
					totalBalance
				} = item;

				const actualIdx = (transactionHistoryPage - 1) * 15 + idx + 1;

				const gamePeriodColumn = `${periode} - ${getTranslatedGameName(langdata, pasar, false)}`;

				const tglbel = new Date(item.tglbel);
				const textTglBel = dateTimeFormat(tglbel, langdata.language_code);

				const isWin = status === "Win",
					isBuy = status === "Buy",
					isRefund = status === "Refund",
					isCorrection = status === "Correction";

				const statusColumn = langdata[`txt_${status.toLowerCase()}`];

				// Colours are from PopupResultHistory
				const debitColumnColour = (
					isBuy ? "red-text" :
						isWin ? "blue-text" :
							isRefund ? "yellow-text" :
								isCorrection ? "green-text" : ""
				);

				const debitCreditColumn = debet ?
					"-" + moneyFormat(debet, langdata.language_code, currency) :
					moneyFormat(kredit, langdata.language_code, currency);


				// Todo: it seems like this component is getting updated every second

				const game = games[pasar];

				// console.log("PTH " + pasar, game);

				if (!game) {
					console.error("PTH " + pasar + ": game is empty! Check \"/games\" in Networks.");
					return null;
				}
				console.log(game);
				console.log(game ? game.name : pasar);
				console.log(pasar);
				return <>
					<tr key={"TH_tHO_tr_" + idx}

						{...{
							game: replaceGameNameWithURL(game ? game.name : pasar),
							periode,
							idbel
						}}

						onClick={toggleTransactionDetail}
					>
						<td>{actualIdx}</td>

						<td>{gamePeriodColumn}</td>
						<td>{textTglBel}</td>
						<td>{statusColumn}</td>

						<td className={debitColumnColour}>
							{debitCreditColumn}
						</td>
						<td>
							{moneyFormat(totalBalance, langdata.language_code, currency)}
						</td>
					</tr>

					{/* 
						Transaction Detail
						Appears on click of the row above, after successfully fetchTransactionDetail
					*/}
					<tr key={"TH_tHO_tr_" + idx + "_1"}
						className={
							"transaction-detail-child" +
							(item.showTransactionDetail && item.transactionDetail
								? " active" : "")
						}>
						<td colSpan={this.headerAry.length}>
							<table>
								<thead>
									<tr>
										{
											isBuy || isRefund || isCorrection
												? this.getDebitHeaders(pasar)
												: this.getWinHeaders(pasar)
										}
									</tr>
								</thead>

								<tbody>
									{
										this.getTransactionDetailRows(item)
									}

									{
										//Win cells
										isWin ? (
											<tr key={"TH_tHO_tD_tr_totalWin"}>
												<td colSpan={this.getWinHeaders(pasar).length}>
													{
														langdata["txt_total_win"]
													} : {
														item.transactionDetail ?
															moneyFormat(item.totalWin, langdata.language_code, currency) :
															0
													}
												</td>
											</tr>
										) : null
									}
								</tbody>
							</table>
						</td>
					</tr>
				</>
			})
		);
	}

	get transactionHistoryTable() {
		const {
			transactionHistoryData,
			changeTransactionPage,
			transactionHistoryPage,

			desktop
		} = this.props;

		return <>
			{this.headerDiv}
			<table key="PTH_table" className={
				"transaction-history-table" +
				(desktop ? " desktop" : "")
			}>
				<thead>
					<tr className="row-header">
						{
							this.headerAry.map((item, idx) =>
								<th key={`TH_tht_th_${idx}`}>{item}</th>
							)
						}
					</tr>
				</thead>

				<tbody>
					{this.splitTransactionTR}
				</tbody>
			</table>

			<Pagination
				key="PTH_Pagination"
				currentPage={transactionHistoryPage}
				splitSize={15}

				//Basic onClick function -- to be used on changing pages
				changePage={changeTransactionPage}
				totalItems={Number(transactionHistoryData.totalTransaction)} />
		</>;
	}

	render() {
		const { transactionHistoryData } = this.props;

		return transactionHistoryData.transaction.length === 0 ?
			this.emptyTransactionHistoryTable
			: this.transactionHistoryTable;
	}
}